var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showSummary
      ? _c("div", [
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("Feedback.OrganisationYearlyReport.Description1"))
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("Feedback.OrganisationYearlyReport.Description2"))
            )
          ]),
          _vm._v(" "),
          _c(
            "table",
            {
              staticClass: "table tablerow mt-4 mb-3",
              attrs: {
                "aria-label": _vm.$t(
                  "Feedback.OrganisationYearlyReport.Details"
                )
              }
            },
            [
              _c("thead", [
                _c("tr", [
                  _c("th", { staticClass: "w-5" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("AidTargetNumberShort")))])
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "w-35" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("Purpose")))])
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "w-10 right" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Feedback.OrganisationYearlyReport.Items.PaidAmount"
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "w-10 right" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Feedback.OrganisationYearlyReport.Items.TransferredAmount"
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "w-10 right" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Feedback.OrganisationYearlyReport.Items.ApprovedProfits"
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "w-10 right" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Feedback.OrganisationYearlyReport.Items.ApprovedExpenses"
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "w-10 right" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Feedback.OrganisationYearlyReport.Items.AmountToTransfer"
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "w-10" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Feedback.OrganisationYearlyReport.Items.IsDivergent"
                          )
                        )
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.summaryItems, function(item) {
                return _vm.summaryItems && _vm.summaryItems.length > 0
                  ? _c("tbody", [
                      _c("tr", [
                        _c("td", { staticClass: "align-baseline normal" }, [
                          _c("span", [_vm._v(_vm._s(item.aidTargetNumber))])
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "align-baseline normal" }, [
                          _c("span", [_vm._v(_vm._s(item.purpose))])
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "align-baseline normal" }, [
                          _c("span", { staticClass: "right" }, [
                            _vm._v(
                              _vm._s(_vm._f("formatNumber")(item.paidAmount)) +
                                " €"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "align-baseline normal" }, [
                          _c("span", { staticClass: "right" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatNumber")(item.transferredAmount)
                              ) + " €"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "align-baseline normal" }, [
                          _c("span", { staticClass: "right" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatNumber")(item.approvedProfits)
                              ) + " €"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "align-baseline normal" }, [
                          _c("span", { staticClass: "right" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatNumber")(item.approvedExpenses)
                              ) + " €"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "align-baseline normal" }, [
                          _c("span", { staticClass: "right" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatNumber")(item.amountToTransfer)
                              ) + " €"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "align-baseline normal" }, [
                          item.isDivergent
                            ? _c("span", { staticClass: "centered" }, [
                                _vm._v(_vm._s(_vm.$t("Yes")))
                              ])
                            : _vm._e()
                        ])
                      ])
                    ])
                  : _vm._e()
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("Feedback.OrganisationYearlyReport.Description3"))
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("Feedback.OrganisationYearlyReport.Description4"))
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.model.feedback && _vm.model.feedback.showDecisionMakers
      ? _c(
          "div",
          [
            _c("p", { staticClass: "mt-5" }, [
              _vm._v(_vm._s(_vm.$t("Feedback.DecisionMakers")))
            ]),
            _vm._v(" "),
            !_vm.model.feedback.inspector.isEmpty
              ? _c("text-label-row", {
                  attrs: {
                    title: "Feedback.Inspector",
                    bold: true,
                    value: _vm.model.feedback.inspector.contactInfo
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.model.feedback.inspector.isEmpty
              ? _c("text-label-row", {
                  attrs: {
                    title: "Feedback.Supervisor",
                    bold: true,
                    value: _vm.model.feedback.supervisor.contactInfo
                  }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }